import { Alert, Card, CardContent, CardHeader, CardTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { IntegrationEnvVariable } from '@/entities/integrations';
import { useHasPermission } from '@/entities/profile';

import { BitrixTouchSendsJournal } from './BitrixTouchSendsJournal';
import { BitrixTouchSettingsForm } from './BitrixTouchSettingsForm';

/** Переменная окружения с адресом, по которому заводится касание: без неё касания не заводятся */
const TOUCH_URL_ENV_NAME = 'INTEGRATION_C2_BITRIX_TOUCH_URL';

type Props = {
  /** Переменные окружения интеграции из её карточки */
  envVariables: IntegrationEnvVariable[];
};

/**
 * Блок режима касания Bitrix24: настройки режима и перечень заведённых касаний.
 */
export const BitrixTouchSection: FC<Props> = ({ envVariables }) => {
  const { t } = useTranslation(['integrations']);
  const canAdmin = useHasPermission('ADMIN_INTEGRATION_INFO');

  const isTouchUrlFilled = envVariables.some((variable) => variable.name === TOUCH_URL_ENV_NAME && variable.isFilled);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">{t('integrations:bitrixTouch.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <p className="text-muted-foreground text-sm">{t('integrations:bitrixTouch.description')}</p>
        {!isTouchUrlFilled && (
          <Alert
            type="warning"
            title={t('integrations:bitrixTouch.noTouchUrl')}
            description={t('integrations:bitrixTouch.noTouchUrlHint', { name: TOUCH_URL_ENV_NAME })}
          />
        )}
        <BitrixTouchSettingsForm canEdit={canAdmin} />
      </CardContent>
      <CardContent>
        <BitrixTouchSendsJournal />
      </CardContent>
    </Card>
  );
};
